import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(({ palette }) => ({
  root: ({ height }) => ({
    backgroundColor: palette.common.black,
    height,
    position: 'relative',
    overflow: 'hidden'
  })
}));

const HeaderContainer = ({ children, height = 560 }) => {
  const classes = useStyles({ height });
  return <div className={classes.root}>{children}</div>;
};

export default HeaderContainer;
